import {useMemo} from "react";
import { ApiClient } from "../../../apis";

export function useApiClient() {
    return useMemo(() => new ApiClient(), []);
}
